import Wizard from './components/class-wizard';
import './components/hero-video';

// The Wizard component prints its invocation script (`new Wizard( {...} )`) in
// the footer, so the class must be available in the global scope.
window.Wizard = Wizard;

/**
 * Wrap content block tables in a horizontally scrollable container.
 *
 * The parent theme renders tables directly inside `.content__type--table`
 * (and WYSIWYG tables inside `.content__type--text`) without a scroll
 * container, so wide tables overflow the layout on small screens.
 */
const hltsamenScrollableTables = () => {
	const tables = document.querySelectorAll( '.content__type--table table, .content__type--text table' );

	if ( ! tables.length ) {
		return;
	}

	// Only make the wrapper keyboard-focusable when it actually scrolls.
	const observer = new ResizeObserver( ( entries ) => {
		entries.forEach( ( { target } ) => {
			const scrollable = target.scrollWidth > target.clientWidth;
			target.classList.toggle( 'table-scroll--scrollable', scrollable );

			if ( scrollable ) {
				target.setAttribute( 'tabindex', '0' );
			} else {
				target.removeAttribute( 'tabindex' );
			}
		} );
	} );

	tables.forEach( ( table ) => {
		if ( table.parentElement.classList.contains( 'table-scroll' ) ) {
			return;
		}

		const wrapper = document.createElement( 'div' );
		wrapper.className = 'table-scroll';
		wrapper.setAttribute( 'role', 'region' );

		const title = table.closest( '.content__type--table' )?.querySelector( '.table__title' );
		wrapper.setAttribute( 'aria-label', title?.textContent.trim() || 'Tabel' );

		table.parentNode.insertBefore( wrapper, table );
		wrapper.appendChild( table );

		observer.observe( wrapper );
	} );
};

if ( 'loading' === document.readyState ) {
	document.addEventListener( 'DOMContentLoaded', hltsamenScrollableTables );
} else {
	hltsamenScrollableTables();
}
